(() => {
  const body = document.body;
  const overlay = document.querySelector("[data-screen-overlay]");
  const menu = document.querySelector("[data-mobile-menu]");
  const cart = document.querySelector("[data-cart-drawer]");
  const search = document.querySelector("[data-search-overlay]");
  const filters = document.querySelector("[data-collection-filters]");
  const login = document.querySelector("[data-login-modal]");

  const openPanel = (panel) => {
    [menu, cart, filters, login].forEach((item) => {
      if (item && item !== panel) {
        item.classList.remove("is-open");
        item.setAttribute("aria-hidden", "true");
      }
    });
    if (search && search !== panel) {
      search.classList.remove("is-open");
      search.setAttribute("aria-hidden", "true");
    }
    panel?.classList.add("is-open");
    panel?.setAttribute("aria-hidden", "false");
    overlay?.classList.add("is-active");
    body.classList.add("is-locked");
  };

  const closePanels = () => {
    menu?.classList.remove("is-open");
    cart?.classList.remove("is-open");
    search?.classList.remove("is-open");
    filters?.classList.remove("is-open");
    login?.classList.remove("is-open");
    [menu, cart, search, login].forEach((item) => item?.setAttribute("aria-hidden", "true"));
    filters?.setAttribute("aria-hidden", window.matchMedia("(max-width: 900px)").matches ? "true" : "false");
    overlay?.classList.remove("is-active");
    body.classList.remove("is-locked");
    document.querySelector("[data-menu-open]")?.setAttribute("aria-expanded", "false");
    document.querySelector("[data-filter-open]")?.setAttribute("aria-expanded", "false");
  };

  document.querySelector("[data-menu-open]")?.addEventListener("click", (event) => {
    openPanel(menu);
    event.currentTarget.setAttribute("aria-expanded", "true");
  });
  document.querySelector("[data-menu-close]")?.addEventListener("click", closePanels);
  document.querySelector("[data-cart-open]")?.addEventListener("click", () => openPanel(cart));
  document.querySelector("[data-cart-close]")?.addEventListener("click", closePanels);
  document.querySelector("[data-search-open]")?.addEventListener("click", () => {
    openPanel(search);
    window.setTimeout(() => document.querySelector("[data-search-input]")?.focus(), 100);
  });
  document.querySelector("[data-search-close]")?.addEventListener("click", closePanels);
  document.querySelectorAll("[data-login-open]").forEach((trigger) => trigger.addEventListener("click", (event) => {
    if (!login) return;
    event.preventDefault();
    openPanel(login);
    window.setTimeout(() => login.querySelector("input[type='email']")?.focus(), 100);
  }));
  document.querySelector("[data-login-close]")?.addEventListener("click", closePanels);
  document.querySelector("[data-filter-open]")?.addEventListener("click", (event) => {
    openPanel(filters);
    event.currentTarget.setAttribute("aria-expanded", "true");
  });
  document.querySelector("[data-filter-close]")?.addEventListener("click", closePanels);
  overlay?.addEventListener("click", closePanels);
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closePanels();
  });

  document.querySelectorAll("[data-mega-item]").forEach((item) => {
    const trigger = item.querySelector("[data-mega-trigger]");
    const setExpanded = (expanded) => trigger?.setAttribute("aria-expanded", String(expanded));
    item.addEventListener("mouseenter", () => setExpanded(true));
    item.addEventListener("mouseleave", () => setExpanded(false));
    item.addEventListener("focusin", () => setExpanded(true));
    item.addEventListener("focusout", (event) => {
      if (!item.contains(event.relatedTarget)) setExpanded(false);
    });
  });

  document.querySelectorAll(".mega-menu").forEach((megaMenu) => {
    const tabs = [...megaMenu.querySelectorAll("[data-mega-tab]")];
    const panels = [...megaMenu.querySelectorAll("[data-mega-panel]")];
    if (!tabs.length || !panels.length) return;

    const activateTab = (name) => {
      megaMenu.dataset.activePanel = name;
      tabs.forEach((tab) => {
        const active = tab.dataset.megaTab === name;
        tab.classList.toggle("is-active", active);
        tab.setAttribute("aria-selected", String(active));
      });
      panels.forEach((panel) => {
        const active = panel.dataset.megaPanel === name;
        panel.classList.toggle("is-active", active);
        panel.hidden = !active;
      });
    };

    tabs.forEach((tab) => {
      const showTab = () => activateTab(tab.dataset.megaTab);
      tab.addEventListener("mouseenter", showTab);
      tab.addEventListener("focus", showTab);
      tab.addEventListener("click", (event) => {
        event.preventDefault();
        showTab();
      });
    });

    const defaultTab = tabs.find((tab) => tab.classList.contains("is-active"))?.dataset.megaTab || tabs[0].dataset.megaTab;
    activateTab(defaultTab);
    megaMenu.closest("[data-mega-item]")?.addEventListener("mouseleave", () => activateTab(defaultTab));
  });

  document.querySelectorAll("[data-promotion-slider]").forEach((slider) => {
    const track = slider.querySelector("[data-promotion-track]");
    const slides = [...slider.querySelectorAll("[data-promotion-slide]")];
    const dots = [...slider.querySelectorAll("[data-promotion-dot]")];
    if (!track || slides.length < 2) return;

    let current = 0;
    let autoplayTimer;
    let activePointer = null;
    let pointerStartX = 0;
    let pointerStartY = 0;
    let pointerDeltaX = 0;
    let pointerDeltaY = 0;
    let dragWidth = 0;
    let isDragging = false;
    let isHovered = false;
    let suppressClick = false;
    const autoplay = slider.dataset.autoplay === "true" && !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const interval = Math.max(3000, Number(slider.dataset.interval) || 6000);

    const render = () => {
      track.style.transform = `translate3d(-${current * 100}%, 0, 0)`;
      slides.forEach((slide, index) => {
        const active = index === current;
        slide.classList.toggle("is-active", active);
        slide.setAttribute("aria-hidden", String(!active));
        slide.querySelectorAll("a, button, input, select, textarea").forEach((control) => {
          if (active) control.removeAttribute("tabindex");
          else control.setAttribute("tabindex", "-1");
        });
      });
      dots.forEach((dot, index) => {
        const active = index === current;
        dot.classList.toggle("is-active", active);
        dot.setAttribute("aria-current", String(active));
      });
    };

    const goTo = (index, restart = true) => {
      current = (index + slides.length) % slides.length;
      render();
      if (restart) startAutoplay();
    };

    const stopAutoplay = () => {
      window.clearInterval(autoplayTimer);
      autoplayTimer = undefined;
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (autoplay && !document.hidden && activePointer === null && !isHovered && !slider.contains(document.activeElement)) {
        autoplayTimer = window.setInterval(() => goTo(current + 1, false), interval);
      }
    };

    dots.forEach((dot) => dot.addEventListener("click", () => goTo(Number(dot.dataset.promotionDot))));
    slider.addEventListener("dragstart", (event) => event.preventDefault());

    slider.addEventListener("pointerdown", (event) => {
      if (event.button !== 0 || event.target.closest("[data-promotion-dot]")) return;
      activePointer = event.pointerId;
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
      pointerDeltaX = 0;
      pointerDeltaY = 0;
      dragWidth = slider.clientWidth;
      isDragging = false;
      stopAutoplay();
      slider.setPointerCapture?.(event.pointerId);
    });

    slider.addEventListener("pointermove", (event) => {
      if (event.pointerId !== activePointer) return;
      pointerDeltaX = event.clientX - pointerStartX;
      pointerDeltaY = event.clientY - pointerStartY;

      if (!isDragging) {
        if (Math.abs(pointerDeltaX) < 5 && Math.abs(pointerDeltaY) < 5) return;
        if (Math.abs(pointerDeltaY) > Math.abs(pointerDeltaX)) return;
        isDragging = true;
        slider.classList.add("is-dragging");
      }

      if (event.cancelable) event.preventDefault();
      let visualDelta = pointerDeltaX;
      if ((current === 0 && visualDelta > 0) || (current === slides.length - 1 && visualDelta < 0)) visualDelta *= 0.28;
      track.style.transform = `translate3d(${(-current * dragWidth) + visualDelta}px, 0, 0)`;
    });

    const finishDrag = (event, cancelled = false) => {
      if (event.pointerId !== activePointer) return;
      const pointerToRelease = activePointer;
      activePointer = null;
      slider.classList.remove("is-dragging");
      if (slider.hasPointerCapture?.(pointerToRelease)) slider.releasePointerCapture(pointerToRelease);

      const threshold = Math.max(45, Math.min(120, dragWidth * 0.12));
      const completedDrag = isDragging && Math.abs(pointerDeltaX) > Math.abs(pointerDeltaY);
      suppressClick = completedDrag && Math.abs(pointerDeltaX) > 8;

      if (!cancelled && completedDrag && Math.abs(pointerDeltaX) >= threshold) {
        current = Math.max(0, Math.min(slides.length - 1, current + (pointerDeltaX < 0 ? 1 : -1)));
      }
      isDragging = false;
      render();
      startAutoplay();
      if (suppressClick) window.setTimeout(() => { suppressClick = false; }, 0);
    };

    slider.addEventListener("pointerup", (event) => finishDrag(event));
    slider.addEventListener("pointercancel", (event) => finishDrag(event, true));
    slider.addEventListener("click", (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);

    slider.addEventListener("pointerenter", (event) => {
      if (event.pointerType !== "mouse") return;
      isHovered = true;
      stopAutoplay();
    });
    slider.addEventListener("pointerleave", (event) => {
      if (event.pointerType !== "mouse") return;
      isHovered = false;
      startAutoplay();
    });
    slider.addEventListener("focusin", stopAutoplay);
    slider.addEventListener("focusout", (event) => {
      if (!slider.contains(event.relatedTarget)) startAutoplay();
    });
    document.addEventListener("visibilitychange", () => document.hidden ? stopAutoplay() : startAutoplay());
    document.addEventListener("shopify:block:select", (event) => {
      const selectedSlide = event.target.closest("[data-promotion-slide]");
      if (!selectedSlide || !slider.contains(selectedSlide)) return;
      stopAutoplay();
      goTo(slides.indexOf(selectedSlide), false);
    });
    document.addEventListener("shopify:block:deselect", startAutoplay);

    render();
    startAutoplay();
  });

  const money = (cents) => {
    const value = (cents / 100).toFixed(2);
    return `${value} DH`;
  };

  const refreshCart = async () => {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`);
    const data = await response.json();
    document.querySelectorAll("[data-cart-count]").forEach((bubble) => {
      bubble.textContent = data.item_count;
      bubble.classList.toggle("is-hidden", data.item_count === 0);
    });
    document.querySelectorAll("[data-cart-title-count]").forEach((count) => {
      count.textContent = data.item_count;
    });

    const content = document.querySelector("[data-cart-content]");
    if (!content) return;
    const placeholder = content.dataset.placeholder || "";
    if (!data.item_count) {
      content.innerHTML = `
        <div class="empty-cart">
          <h3>Your cart is waiting</h3>
          <p>Fill it with honest food for your favorite companion.</p>
          <a class="button button--dark" href="${window.Shopify.routes.root}collections/all">SHOP BESTSELLERS</a>
        </div>`;
      return;
    }

    const items = data.items.map((item, index) => `
      <div class="cart-item" data-line="${index + 1}">
        <a href="${item.url}"><img class="cart-item__image" src="${item.image || placeholder}" alt="${item.image ? item.product_title.replace(/"/g, "&quot;") : "Product image placeholder"}"></a>
        <div class="cart-item__details">
          <span>${(item.product_type || "PET FOOD").toUpperCase()}</span>
          <h3><a href="${item.url}">${item.product_title}</a></h3>
          <p>${money(item.final_line_price)}</p>
          <div class="quantity-selector">
            <button type="button" data-cart-change data-line="${index + 1}" data-quantity="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-cart-change data-line="${index + 1}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
          </div>
        </div>
      </div>`).join("");

    content.innerHTML = `
      <div class="cart-items">${items}</div>
      <div class="cart-drawer__footer">
        <div class="subtotal"><span>Subtotal</span><b>${money(data.total_price)}</b></div>
        <a class="button button--dark" href="${window.Shopify.routes.root}cart">VIEW CART</a>
        <form action="${window.Shopify.routes.root}cart" method="post">
          <button class="button button--accent" type="submit" name="checkout">CHECKOUT →</button>
        </form>
      </div>`;
  };

  document.addEventListener("submit", async (event) => {
    const form = event.target.closest(".quick-add-form, .product-form");
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector("[type='submit']");
    const original = button?.innerHTML;
    if (button) {
      button.disabled = true;
      button.textContent = "Adding…";
    }
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error("Unable to add item");
      await refreshCart();
      openPanel(cart);
    } catch (error) {
      window.alert(error.message);
    } finally {
      if (button) {
        button.disabled = false;
        button.innerHTML = original;
      }
    }
  });

  document.addEventListener("click", async (event) => {
    const button = event.target.closest("[data-cart-change]");
    if (!button) return;
    button.disabled = true;
    try {
      await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: Number(button.dataset.line), quantity: Number(button.dataset.quantity) })
      });
      await refreshCart();
    } finally {
      button.disabled = false;
    }
  });

  document.querySelectorAll("[data-testimonials]").forEach((section) => {
    const slides = [...section.querySelectorAll("[data-testimonial-slide]")];
    if (!slides.length) return;
    let current = 0;
    const render = () => {
      slides.forEach((slide, index) => slide.classList.toggle("is-active", index === current));
      const counter = section.querySelector("[data-testimonial-current]");
      if (counter) counter.textContent = String(current + 1).padStart(2, "0");
    };
    section.querySelector("[data-testimonial-prev]")?.addEventListener("click", () => {
      current = (current - 1 + slides.length) % slides.length;
      render();
    });
    section.querySelector("[data-testimonial-next]")?.addEventListener("click", () => {
      current = (current + 1) % slides.length;
      render();
    });
  });

  document.querySelectorAll("[data-variant-select]").forEach((select) => {
    select.addEventListener("change", () => {
      const option = select.options[select.selectedIndex];
      const price = select.closest("[data-product-section]")?.querySelector("[data-product-price] .price span");
      if (price && option.dataset.price) price.textContent = option.dataset.price;
    });
  });

  document.querySelector("[data-sort-select]")?.addEventListener("change", (event) => {
    const url = new URL(window.location.href);
    url.searchParams.set("sort_by", event.target.value);
    window.location.assign(url.toString());
  });

  document.querySelectorAll("[data-grid-view]").forEach((button) => {
    button.addEventListener("click", () => {
      const listView = button.dataset.gridView === "list";
      document.querySelector("[data-collection-grid]")?.classList.toggle("is-list", listView);
      document.querySelectorAll("[data-grid-view]").forEach((item) => item.classList.toggle("is-active", item === button));
    });
  });

  document.querySelectorAll("[data-category-slider]").forEach((slider) => {
    let dragging = false;
    let moved = false;
    let startX = 0;
    let startScroll = 0;

    slider.addEventListener("pointerdown", (event) => {
      if (!window.matchMedia("(max-width: 749px)").matches || event.pointerType !== "mouse") return;
      dragging = true;
      moved = false;
      startX = event.clientX;
      startScroll = slider.scrollLeft;
      slider.setPointerCapture?.(event.pointerId);
    });

    slider.addEventListener("pointermove", (event) => {
      if (!dragging) return;
      const distance = event.clientX - startX;
      if (Math.abs(distance) > 5) moved = true;
      slider.scrollLeft = startScroll - distance;
    });

    const stopDragging = (event) => {
      if (!dragging) return;
      dragging = false;
      slider.releasePointerCapture?.(event.pointerId);
    };
    slider.addEventListener("pointerup", stopDragging);
    slider.addEventListener("pointercancel", stopDragging);
    slider.addEventListener("click", (event) => {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }, true);
  });
})();
